import React from 'react'
import PropTypes from 'prop-types'
import URI from 'urijs'
import { get } from 'lodash-es'

import './VideoPlayerComponent.scss'

const getObjectURL = (
  object,
  objectType,
  useBuiltinPlayer,
  customOptions = {}
) => {
  const baseURL = new URI(
    useBuiltinPlayer
      ? '/glue-standard.ihtml/player.html'
      : '/v.ihtml/player.html'
  )
  const defaultOptions = {
    token: object.token,
    showDescriptions: 0,
    source: 'admin',
    autoPlay: 0,
  }

  if (objectType === 'live') {
    defaultOptions.live_id = object.live_id
  } else {
    defaultOptions.photo_id = object.photo_id
  }

  if (customOptions.mutedAutoPlay) {
    delete defaultOptions.autoPlay
  }

  baseURL.query({
    ...defaultOptions,
    ...customOptions,
  })

  return baseURL.toString()
}

const iframePixelFix = () => {
  const video = document.body
    .querySelector('iframe#videoplayer')
    .contentWindow.document.querySelector('video')
  if (video) {
    video.style.width = 'calc(100% + 1px)'
    video.style.height = 'calc(100% + 1px)'
  }
}

const VideoPlayerComponent = ({
  object,
  objectType,
  options,
  useBuiltinPlayer = false,
  iframeRef,
}) => {
  const src = getObjectURL(object, objectType, useBuiltinPlayer, options)

  return (
    <div className="video-player-component">
      <iframe
        id="videoplayer"
        ref={iframeRef}
        src={src}
        frameBorder="0"
        scrolling="no"
        allowFullScreen
        title={get(object, 'title', 'Video Player')}
        onLoad={iframePixelFix}
      />
    </div>
  )
}

VideoPlayerComponent.propTypes = {
  object: PropTypes.object,
  objectType: PropTypes.oneOf(['live', 'photo']),
  options: PropTypes.object,
  useBuiltinPlayer: PropTypes.bool,
  iframeRef: PropTypes.object,
}

export default VideoPlayerComponent
